import {
  Edit,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
} from "react-admin";

export const GroupEdit = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("groups.edit") ||
      permissions.includes("groups.*") ||
      permissions.includes("*")
    )
  )
    return null;

  return (
    <Edit title="Edit Group" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Group updated successfully", { type: "success" })
        }
      >
        <TextInput source="name" />
        <TextInput source="description" />
      </SimpleForm>
    </Edit>
  );
};